
import Vue from 'vue'

const locales = {keys(){return []}}
global['____35C5A20____'] = true;
delete global['____35C5A20____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app","navigationBarBackgroundColor":"#FFFFFF","backgroundColor":"#f8f8f8"},"tabBar":{"color":"#8a8a8a","selectedColor":"#1890ff","borderStyle":"black","backgroundColor":"#ffffff","list":[{"pagePath":"pages/index/index","iconPath":"static/tab-home.png","selectedIconPath":"static/selectHome.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/mall/index","iconPath":"static/tab-lianmeng-icon.png","selectedIconPath":"static/tab-lianmeng-current.png","text":"商城","redDot":false,"badge":""},{"pagePath":"pages/knowledge/list","iconPath":"static/tab-ky.png","selectedIconPath":"static/tab-ky-current.png","text":"康养知识","redDot":false,"badge":""},{"pagePath":"pages/user/user","iconPath":"static/tab-my.png","selectedIconPath":"static/tab-my-current.png","text":"我的","redDot":false,"badge":""}]},"condition":{"current":0,"list":[{"name":"","path":"","query":""}]}};
global.__uniConfig.compilerVersion = '4.56';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__35C5A20';
global.__uniConfig.appName = '东江聚力';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-resetpwd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/resetpwd"+'.vue')), 'pages-public-resetpwd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/register"+'.vue')), 'pages-public-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mall-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/mall/index"+'.vue')), 'pages-mall-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/notice/list"+'.vue')), 'pages-notice-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-noticeDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/notice/noticeDetail"+'.vue')), 'pages-notice-noticeDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-knowledge-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/knowledge/list"+'.vue')), 'pages-knowledge-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-knowledge-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/knowledge/detail"+'.vue')), 'pages-knowledge-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-user', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/user/user"+'.vue')), 'pages-user-user'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/login"+'.vue')), 'pages-public-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-inviteLand', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/inviteLand"+'.vue')), 'pages-public-inviteLand'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-faq', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/faq"+'.vue')), 'pages-public-faq'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-userAgreement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/userAgreement"+'.vue')), 'pages-public-userAgreement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-privacyStatement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/public/privacyStatement"+'.vue')), 'pages-public-privacyStatement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay-pay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/pay/pay"+'.vue')), 'pages-pay-pay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay-success', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pages/pay/success"+'.vue')), 'pages-pay-success'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMall-product-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesMall/product/detail"+'.vue')), 'pagesMall-product-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMall-product-zoneList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesMall/product/zoneList"+'.vue')), 'pagesMall-product-zoneList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMall-order-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesMall/order/list"+'.vue')), 'pagesMall-order-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMall-order-create', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesMall/order/create"+'.vue')), 'pagesMall-order-create'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMall-order-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesMall/order/detail"+'.vue')), 'pagesMall-order-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMall-coupon-center', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesMall/coupon/center"+'.vue')), 'pagesMall-coupon-center'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-profile', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/profile"+'.vue')), 'pagesUser-user-profile'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-content', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/content"+'.vue')), 'pagesUser-user-content'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-address-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/address/list"+'.vue')), 'pagesUser-address-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-address-upsert', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/address/upsert"+'.vue')), 'pagesUser-address-upsert'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-updatePayPass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/updatePayPass"+'.vue')), 'pagesUser-user-updatePayPass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-updateName', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/updateName"+'.vue')), 'pagesUser-user-updateName'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-balance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/balance"+'.vue')), 'pagesUser-finance-balance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-balanceTransfer', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/balanceTransfer"+'.vue')), 'pagesUser-finance-balanceTransfer'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-balanceWater', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/balanceWater"+'.vue')), 'pagesUser-finance-balanceWater'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-integralWater', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/integralWater"+'.vue')), 'pagesUser-finance-integralWater'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-bonusRecord', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/bonusRecord"+'.vue')), 'pagesUser-finance-bonusRecord'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-activeValue', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/activeValue"+'.vue')), 'pagesUser-finance-activeValue'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-assistanceFund', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/assistanceFund"+'.vue')), 'pagesUser-finance-assistanceFund'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-finance-lockBonus', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/finance/lockBonus"+'.vue')), 'pagesUser-finance-lockBonus'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-myTeam', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/myTeam"+'.vue')), 'pagesUser-user-myTeam'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-directDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/directDetail"+'.vue')), 'pagesUser-user-directDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-teamDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/teamDetail"+'.vue')), 'pagesUser-user-teamDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-invateCode', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/invateCode"+'.vue')), 'pagesUser-user-invateCode'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-receivingAccount', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/receivingAccount"+'.vue')), 'pagesUser-user-receivingAccount'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-receivingAccountEdit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/receivingAccountEdit"+'.vue')), 'pagesUser-user-receivingAccountEdit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-withdraw', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/withdraw"+'.vue')), 'pagesUser-user-withdraw'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-withdrawList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/withdrawList"+'.vue')), 'pagesUser-user-withdrawList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-bindphone', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/bindphone"+'.vue')), 'pagesUser-user-bindphone'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-auth-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/auth/index"+'.vue')), 'pagesUser-user-auth-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-coupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/coupon"+'.vue')), 'pagesUser-user-coupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesUser-user-agentApply', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/workspaces/dongjiangyc/dongjiangyc2.0/dongjiangyc-uniapp/src/pagesUser/user/agentApply"+'.vue')), 'pagesUser-user-agentApply'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"东江惠购","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/public/resetpwd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"重置密码","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-resetpwd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-resetpwd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/resetpwd',
  windowTop:0
}
},
{
path: '/pages/public/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/register',
  windowTop:0
}
},
{
path: '/pages/mall/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"商城","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-mall-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-mall-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mall/index',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/notice/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告列表","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-notice-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/list',
  windowTop:0
}
},
{
path: '/pages/notice/noticeDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告详情","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-notice-noticeDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-noticeDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/noticeDetail',
  windowTop:0
}
},
{
path: '/pages/knowledge/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"康养知识","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-knowledge-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-knowledge-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/knowledge/list',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/knowledge/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"康养知识详情","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-knowledge-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-knowledge-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/knowledge/detail',
  windowTop:0
}
},
{
path: '/pages/user/user',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"enablePullDownRefresh":false,"navigationBarTitleText":"我的","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-user-user', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-user-user',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/user',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/public/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/login',
  windowTop:0
}
},
{
path: '/pages/public/inviteLand',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"东江惠购","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-inviteLand', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-inviteLand',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/inviteLand',
  windowTop:0
}
},
{
path: '/pages/public/faq',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"常见问题","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-faq', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-faq',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/faq',
  windowTop:0
}
},
{
path: '/pages/public/userAgreement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户协议","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-userAgreement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-userAgreement',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/userAgreement',
  windowTop:0
}
},
{
path: '/pages/public/privacyStatement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私声明","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-public-privacyStatement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-privacyStatement',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/privacyStatement',
  windowTop:0
}
},
{
path: '/pages/pay/pay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-pay-pay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay-pay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay/pay',
  windowTop:0
}
},
{
path: '/pages/pay/success',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付结果","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-pay-success', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay-success',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay/success',
  windowTop:0
}
},
{
path: '/pagesMall/product/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"详情展示","titleNView":{"type":"transparent"}})
      },
      [
        createElement('pagesMall-product-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMall-product-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMall/product/detail',
  windowTop:0
}
},
{
path: '/pagesMall/product/zoneList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报单专区","navigationStyle":"custom","enablePullDownRefresh":true,"titleNView":false})
      },
      [
        createElement('pagesMall-product-zoneList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMall-product-zoneList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMall/product/zoneList',
  windowTop:0
}
},
{
path: '/pagesMall/order/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesMall-order-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMall-order-list',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMall/order/list',
  windowTop:0
}
},
{
path: '/pagesMall/order/create',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交订单","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesMall-order-create', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMall-order-create',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMall/order/create',
  windowTop:0
}
},
{
path: '/pagesMall/order/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesMall-order-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMall-order-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMall/order/detail',
  windowTop:0
}
},
{
path: '/pagesMall/coupon/center',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领券中心","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesMall-coupon-center', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMall-coupon-center',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMall/coupon/center',
  windowTop:0
}
},
{
path: '/pagesUser/user/profile',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人信息","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-profile', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-profile',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/profile',
  windowTop:0
}
},
{
path: '/pagesUser/user/content',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"详情","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-content', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-content',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/content',
  windowTop:0
}
},
{
path: '/pagesUser/address/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-address-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-address-list',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/address/list',
  windowTop:0
}
},
{
path: '/pagesUser/address/upsert',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","disableScroll":true,"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-address-upsert', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-address-upsert',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/address/upsert',
  windowTop:0
}
},
{
path: '/pagesUser/user/updatePayPass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改交易密码","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-updatePayPass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-updatePayPass',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/updatePayPass',
  windowTop:0
}
},
{
path: '/pagesUser/user/updateName',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改昵称","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-updateName', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-updateName',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/updateName',
  windowTop:0
}
},
{
path: '/pagesUser/finance/balance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":false,"navigationBarTitleText":"消费积分转赠","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-balance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-balance',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/balance',
  windowTop:0
}
},
{
path: '/pagesUser/finance/balanceTransfer',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"消费积分转赠记录","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-balanceTransfer', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-balanceTransfer',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/balanceTransfer',
  windowTop:0
}
},
{
path: '/pagesUser/finance/balanceWater',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"消费积分明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-balanceWater', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-balanceWater',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/balanceWater',
  windowTop:0
}
},
{
path: '/pagesUser/finance/integralWater',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"积分明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-integralWater', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-integralWater',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/integralWater',
  windowTop:0
}
},
{
path: '/pagesUser/finance/bonusRecord',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"奖励明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-bonusRecord', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-bonusRecord',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/bonusRecord',
  windowTop:0
}
},
{
path: '/pagesUser/finance/activeValue',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"活跃值记录","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-activeValue', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-activeValue',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/activeValue',
  windowTop:0
}
},
{
path: '/pagesUser/finance/assistanceFund',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"帮扶基金明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-assistanceFund', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-assistanceFund',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/assistanceFund',
  windowTop:0
}
},
{
path: '/pagesUser/finance/lockBonus',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"锁定收益明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-finance-lockBonus', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-finance-lockBonus',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/finance/lockBonus',
  windowTop:0
}
},
{
path: '/pagesUser/user/myTeam',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":false,"navigationBarTitleText":"会员级别","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-myTeam', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-myTeam',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/myTeam',
  windowTop:0
}
},
{
path: '/pagesUser/user/directDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"直推明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-directDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-directDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/directDetail',
  windowTop:0
}
},
{
path: '/pagesUser/user/teamDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"团队明细","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-teamDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-teamDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/teamDetail',
  windowTop:0
}
},
{
path: '/pagesUser/user/invateCode',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请好友","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-invateCode', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-invateCode',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/invateCode',
  windowTop:0
}
},
{
path: '/pagesUser/user/receivingAccount',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款账户","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-receivingAccount', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-receivingAccount',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/receivingAccount',
  windowTop:0
}
},
{
path: '/pagesUser/user/receivingAccountEdit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑收款账户","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-receivingAccountEdit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-receivingAccountEdit',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/receivingAccountEdit',
  windowTop:0
}
},
{
path: '/pagesUser/user/withdraw',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"奖励发放","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-withdraw', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-withdraw',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/withdraw',
  windowTop:0
}
},
{
path: '/pagesUser/user/withdrawList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"发放记录","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-withdrawList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-withdrawList',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/withdrawList',
  windowTop:0
}
},
{
path: '/pagesUser/user/bindphone',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-bindphone', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-bindphone',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/bindphone',
  windowTop:0
}
},
{
path: '/pagesUser/user/auth/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"实名认证","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-auth-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-auth-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/auth/index',
  windowTop:0
}
},
{
path: '/pagesUser/user/coupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-coupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-coupon',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/coupon',
  windowTop:0
}
},
{
path: '/pagesUser/user/agentApply',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请成为代理","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pagesUser-user-agentApply', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesUser-user-agentApply',
  isNVue:false,maxWidth:0,
  pagePath:'pagesUser/user/agentApply',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
